module.exports = __webpack_public_path__ + "assets/img/txt-tutorial00.f4150185.png";